import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IUnitFormatting } from "@gtmhub/shared/models";
import { ValueFormatOptions, formatValue } from "@webapp/shared/components/formatted-value/utils";
import { ShortNumberPipe } from "@webapp/shared/pipes/short-number/short-number.pipe";

@Component({
  selector: "formatted-value",
  templateUrl: "formatted-value.component.html",
  styleUrls: ["formatted-value.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class.has-custom-formatting]": `!hasBuiltInFormattingUnit`,
  },
})
export class FormattedValueComponent implements OnChanges {
  @Input() public value: number;
  @Input() public formatting: IUnitFormatting;
  @Input() public maxFormattingUnitWidth = "100px";
  @Input() public maximumFractionDigits = 10;

  public formattedValue: string;
  public hasBuiltInFormattingUnit: boolean;
  private builtInUnits = new Set(["$", "£", "€", "%"]);

  constructor(private shortNumberPipe: ShortNumberPipe) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.value || changes.formatting) {
      this.hasBuiltInFormattingUnit = this.isBuiltInUnitPresent();
      this.formattedValue = this.generateFormattedValue();
    }
  }

  private isBuiltInUnitPresent(): boolean {
    const unit = this.formatting.prefix || this.formatting.suffix;
    if (unit) {
      return this.isUnitBuiltIn(unit);
    } else {
      return true;
    }
  }

  private generateFormattedValue(): string {
    const { fractionSize } = this.formatting;
    const options: ValueFormatOptions = { fractionSize, maxFractionDigits: this.maximumFractionDigits };

    return formatValue(this.value, this.shortNumberPipe, options);
  }

  private isUnitBuiltIn(unit: string): boolean {
    return this.builtInUnits.has(unit);
  }
}
